import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/gym/$venueUuid/settings/labels")({
  component: Outlet,
  beforeLoad: () => {
    return {
      // Labels belong to the venue, so switching venue goes back to the main settings page.
      switchVenueLinkOpts: {
        path: "/gym/$venueUuid/settings",
      },
    };
  },
});
